import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export default class RadioButton extends React.Component {
    shouldComponentUpdate(nextProps) {
        return (
            nextProps.value !== this.props.value ||
            nextProps.isChecked !== this.props.isChecked ||
            nextProps.checked !== this.props.checked ||
            nextProps.disabled !== this.props.disabled
        );
    }

    render() {
        const props = this.props;
        const rbtnId = `rbtn-${props.name}-${props.id || props.value}`;
        return (
            <label
                key={props.id}
                htmlFor={rbtnId}
                className={`rbtn ${props.class ? props.class : ''}`}
            >
                <input
                    type="radio"
                    name={props.name}
                    disabled={props.disabled}
                    className="rbtn--input"
                    id={rbtnId}
                    value={props.value}
                    defaultChecked={props.isChecked || props.checked ? 'on' : ''}
                    onChange={() =>
                        !props.disabled ? props.onChange(props.id || props.value) : null
                    }
                />
                <span className="rbtn--radiobutton" />
                <span className={'rbtn--label' + (props.disabled ? ' disabled' : '')}>
                    {props.children || props.value}
                </span>
            </label>
        );
    }
}

RadioButton.defaultProps = {};

RadioButton.propTypes = {
    id: PropTypes.string,
    disabled: PropTypes.bool,
    class: PropTypes.string,
    name: PropTypes.string,
    isChecked: PropTypes.bool,
    checked: PropTypes.bool,
    value: PropTypes.string,
    children: PropTypes.node
};
